import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";

import { ToastProvider } from "../shared/ui/ToastProvider";
import { PageExitGuardProvider } from "../shared/ui/PageExitGuard";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 15_000
    }
  }
});

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider><PageExitGuardProvider>{children}</PageExitGuardProvider></ToastProvider>
    </QueryClientProvider>
  );
}
